import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items, tone = "light" }) {
  const base = tone === "dark" ? "text-ivory/60" : "text-ink-soft";
  const active = tone === "dark" ? "text-ivory" : "text-anthracite";
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className={`flex items-center flex-wrap gap-1.5 text-[0.7rem] tracking-[0.1em] uppercase font-semibold ${base}`}>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.to} className="inline-flex items-center gap-1.5">
            {last ? (
              <span className={active} aria-current="page">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:underline underline-offset-4">{it.label}</Link>
            )}
            {!last && <ChevronRight size={12} className="opacity-50" />}
          </span>
        );
      })}
    </nav>
  );
}
